const secondColor = "#E85B6C";

export default {
  progressBarBackGround: "#33CEFF",
  lifeThreatingText: secondColor
};
